module.exports = require("element-resize-detector");


//////////////////
// WEBPACK FOOTER
// external "element-resize-detector"
// module id = 8
// module chunks = 0